import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { MarketdateBooth } from './marketdate-booth.model';
import { MarketdateBoothPopupService } from './marketdate-booth-popup.service';
import { MarketdateBoothService } from './marketdate-booth.service';

@Component({
    selector: 'jhi-marketdate-booth-delete-dialog',
    templateUrl: './marketdate-booth-delete-dialog.component.html'
})
export class MarketdateBoothDeleteDialogComponent {

    marketdateBooth: MarketdateBooth;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private marketdateBoothService: MarketdateBoothService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['marketdateBooth', 'contractType', 'energyPriceType', 'marketdateBoothStatus']);
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete(id: number) {
        this.marketdateBoothService.delete(id).subscribe((response) => {
            this.eventManager.broadcast({
                name: 'marketdateBoothListModification',
                content: 'Deleted an marketdateBooth'
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'jhi-marketdate-booth-delete-popup',
    template: ''
})
export class MarketdateBoothDeletePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private marketdateBoothPopupService: MarketdateBoothPopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
            this.modalRef = this.marketdateBoothPopupService
                .open(MarketdateBoothDeleteDialogComponent, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate-booth/marketdate-booth-delete-dialog.component.ts